import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CadastrarCnaeModalComponent } from './cadastrar-cnae-modal/cadastrar-cnae-modal.component';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

// jquery
declare const $: any;

@Component({
  selector: 'app-cnae-modal',
  templateUrl: './cnae-modal.component.html',
  styleUrls: ['./cnae-modal.component.scss']
})
export class CnaeModalComponent implements OnInit {
  cnaes: string[] = [];
  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialog: MatDialog,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    public dialogRef: MatDialogRef<CnaeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (this.data && this.data.cnaes) {
      this.atualizaCnaes(this.data.cnaes);
    }
  }

  ngOnInit(): void {
  }

  atualizaCnaes(cnaesString: string) {
    this.cnaes = cnaesString.split(';');
  }

  novoCnae() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarCnaeModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.cnaes.push(res.cnae);
    });
  }

  editarCnae(cnae: string, index: number) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarCnaeModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { cnae, index },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.cnaes[res.index] = res.cnae;
    });
  }

  excluirCnae(index: number) {
    this.cnaes = this.cnaes.filter((p, i) => i !== index);
  }

  salvar() {
    const result = this.cnaes.length ? this.cnaes.join(';') : '';
    this.dialogRef.close(result);
  }
}
